import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M29 24.46l-2.33 2.32V11.5a.65.65 0 0 0-.65-.65H20v1.3h5.35v14.63L23 24.46l-.91.92L25 28.25a1.45 1.45 0 0 0 2 0l2.87-2.87zM13.67 4.29a7.4 7.4 0 0 1 3.16.71l.56-1.17A8.61 8.61 0 0 0 13.67 3a8.77 8.77 0 0 0-8.26 5.85H2v1.3h3.06a9.33 9.33 0 0 0-.15 1.6 8 8 0 0 0 .09 1.1H2v1.3h3.25a8.77 8.77 0 0 0 8.42 6.35 8.61 8.61 0 0 0 3.72-.84l-.56-1.17a7.43 7.43 0 0 1-10.21-4.34H13v-1.3H6.3a8 8 0 0 1-.09-1.1 7.07 7.07 0 0 1 .18-1.6H14v-1.3H6.8a7.45 7.45 0 0 1 6.87-4.56z' })
));